// Flow types automatically removed

import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { useIntl, FormattedMessage } from 'dibs-react-intl';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { DesignerDirectorySearch } from './DesignerDirectorySearch';
import { DesignerDirectoryLocationFilter } from './DesignerDirectoryLocationFilter';
import { getSortOptions, getSortLabel } from '../helpers/sortOptions';
import styles from './styles/DesignerDirectoryHeader.scss';
export function DesignerDirectoryHeaderComponent({
    locationFilter,
    onLocationFilterChange,
    onSortByChange,
    sortBy,
    showOnlyTpnFirms,
    showTestFirms,
    viewer,
}) {
    const intl = useIntl();
    return (
        <div className="rowFlex">
            <div className="colXs12">
                <div className={styles.barHeader} data-tn="design-firms-header">
                    <FormattedMessage
                        id="abt.DesignerDirectory.header"
                        defaultMessage="Design Firm Directory"
                    />
                    <div className={styles.barHeaderBar} />
                </div>
                <div className={styles.subheader}>
                    <FormattedMessage
                        id="abt.DesignerDirectory.subheader"
                        defaultMessage="View the work of the world's best interior designers"
                    />
                </div>
                <div className={styles.searchRow}>
                    <DesignerDirectorySearch
                        showOnlyTpnFirms={showOnlyTpnFirms}
                        showTestFirms={showTestFirms}
                        viewer={viewer}
                    />
                </div>
                <div className={styles.filterRow}>
                    <div className={styles.filterElement}>
                        <DesignerDirectoryLocationFilter
                            locationSelection={locationFilter}
                            onLocationFilterChange={onLocationFilterChange}
                            viewer={viewer}
                        />
                    </div>
                    <div className={styles.filterElement}>
                        <BasicSelect
                            dataTn="design-firms-sort"
                            name="design-firms-sort"
                            label={getSortLabel(intl)}
                            onChange={e => onSortByChange(e.target.value)}
                            options={getSortOptions(intl)}
                            value={sortBy}
                            size="medium"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export const DesignerDirectoryHeader = createFragmentContainer(DesignerDirectoryHeaderComponent, {
    viewer: graphql`
        fragment DesignerDirectoryHeader_viewer on Viewer {
            ...DesignerDirectorySearch_viewer
            ...DesignerDirectoryLocationFilter_viewer
        }
    `,
});
DesignerDirectoryHeader.displayName = 'DesignerDirectoryHeader';
